import { Container, Row } from 'reactstrap';
import { EditProfileTitle, Users } from '../../../../constants';
import Breadcrumbs from '../../../../coreComponents/breadcrumbs';
import MyProfile from './myProfile';

import {
  useGetUserProfileDataQuery,
  useUpdateUserProfileDataMutation,
} from '../../../../reduxToolkit/reducers/usersSlice';

import ProfileStudyProgress from './studyProgress';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../reduxToolkit/hooks';
import { useEffect } from 'react';
import Swal from 'sweetalert2';

const EditProfileContainer = () => {
  const { t } = useTranslation();
  const userEmail = useAppSelector((state) => state.auth.email);
  const { data: profileData, isError, isSuccess } = useGetUserProfileDataQuery({ userEmail });
  const [profileUpdate, { isSuccess: isUpdateSuccess, status }] =
    useUpdateUserProfileDataMutation();

  const profileUpdateHandler = async (
    data:
      | { firstName: string; lastName: string; dob: string | null; city: string }
      | { photo: File },
  ) => {
    if ('photo' in data) {
      const { photo } = data;
      const formData = new FormData();
      formData.append('photo', photo);
      try {
        const res = await profileUpdate(formData).unwrap();
        console.log('Photo updated res', res);
        if (res.success) {
          Swal.fire({
            icon: 'success',
            title: t('profilePage.photoUpdateSuccessTitle'),
            text: t('profilePage.photoUpdateSuccessText'),
            timer: 2000,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error('Failed to update profile photo:', error);
        Swal.fire({
          icon: 'error',
          title: t('profilePage.photoUpdateErrorTitle'),
          text: t('profilePage.photoUpdateErrorText'),
        });
      }
    } else {
      const { firstName, lastName, dob, city } = data;
      const formData = new FormData();
      formData.append('id', profileData!.user.id);
      formData.append('firstName', firstName);
      formData.append('lastName', lastName);
      formData.append('dob', dob ?? '');
      formData.append('city', city ?? '');
      try {
        const res = await profileUpdate(formData).unwrap();
        console.log('Profile updated res', res);
        if (res.success) {
          Swal.fire({
            icon: 'success',
            title: t('profilePage.updateSuccessTitle'),
            text: t('profilePage.updateSuccessText'),
            timer: 2000,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error('Failed to update profile:', error);
        Swal.fire({
          icon: 'error',
          title: t('profilePage.updateErrorTitle'),
          text: t('profilePage.updateErrorText'),
        });
      }
    }
  };

  return (
    <>
      <Breadcrumbs mainTitle={t('profilePage.pageTitle')} />
      <Container fluid>
        <div className="edit-profile">
          {isSuccess && profileData && (
            <Row>
              <MyProfile {...profileData.user} updater={profileUpdateHandler} />
              <ProfileStudyProgress />
              {/* <EditProfileForm /> */}
              {/* <Projects /> */}
            </Row>
          )}
        </div>
      </Container>
    </>
  );
};

export default EditProfileContainer;
